import script from "./TransactionGroupCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionGroupCard.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionGroupCard.vue?vue&type=style&index=0&id=06971a97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06971a97"]])

export default __exports__